import { useContext } from 'react';
import { Col as AntdCol } from 'antd';
import { HomeContext } from 'contexts/home/context';
import { Row } from './styledComponent';
import { WelcomeMessage } from './WelcomeMessage';
import { ReminderMessage } from './ReminderMessage';
import GreetingManIcon from 'assets/images/greeting-man.svg';
import ReminderMessageIcon from 'assets/images/reminder-message.svg';

const GreetingSection = () => {
  const { state } = useContext(HomeContext);

  const isReminder = (state.userAccess?.reminders?.length ?? 0) > 0;
  const reminderMessage = state.userAccess?.reminders[0];
  const reminderIcon = reminderMessage?.imageUrl ?? ReminderMessageIcon;

  return (
    <Row align="middle" gutter={[16, 16]}>
      <AntdCol>
        <img style={{ width: 88 }} src={isReminder ? reminderIcon : GreetingManIcon} alt="home greeting" />
      </AntdCol>
      {isReminder ? <ReminderMessage message={reminderMessage} /> : <WelcomeMessage />}
    </Row>
  );
};

export default GreetingSection;
